(() => {
  if (customElements.get('kc-product-card')) return;
  const palette = { 'bebek mavisi':'#aacfe8','bebek pembesi':'#f5c4d6','beyaz':'#fff','bordo':'#7b1938','krem':'#f3e6c8','krem - 2':'#ebe0bd','ekru':'#f5edda','fuşya':'#d72987','kırmızı':'#c82333','koyu yeşil':'#164d38','gold':'#c5a34a','kamel gold':'#b78c52','gümüş':'#b8bdc4','lila':'#bd9cd8','mor':'#753c95','saks mavisi':'#205bc4','sarı':'#f4d742','siyah':'#222','somon':'#efa48f','turuncu':'#ec8636','zümrüt':'#168461','pudra':'#d9b3ae','rose gold':'#bf8e83','kahverengi':'#79513c','fıstık yeşili':'#a9c66f','lacivert':'#202d54','mürdüm':'#69364f','haki':'#7a8150','turkuaz':'#42bfc1','şeker pembe':'#f49cc7','pembe':'#ed9dc1','siklamen':'#c52f79' };
  customElements.define('kc-product-card', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const data = this.querySelector('[data-card-variants]');
      if (!data) return;
      this.initialized = true;
      this.variants = JSON.parse(data.textContent);
      this.buildColors();
      this.selectVariant(this.dataset.selectedId || this.dataset.defaultId);
    }
    buildColors() {
      const holder = this.querySelector('[data-colors]');
      if (!holder) return;
      holder.replaceChildren();
      const limit = window.matchMedia('(max-width: 749px)').matches ? 3 : 4;
      const groups = new Map();
      for (const v of this.variants) {
        if (!v.color) continue;
        const existing = groups.get(v.color);
        if (!existing || (!existing.available && v.available)) groups.set(v.color, v);
      }
      const values = [...groups.values()];
      const selectedIndex = values.findIndex(v => String(v.id) === (this.dataset.selectedId || this.dataset.defaultId));
      if (selectedIndex >= limit) values.splice(limit - 1, 0, values.splice(selectedIndex, 1)[0]);
      values.forEach((v, index) => {
        if (index >= limit) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kc-color-button';
        button.dataset.color = v.color;
        button.setAttribute('aria-label', v.color + (v.available ? '' : ' — stokta yok'));
        button.title = v.color + (v.available ? '' : ' — stokta yok');
        const dot = document.createElement('span');
        dot.className = 'kc-color-dot';
        dot.style.backgroundColor = palette[v.color.toLocaleLowerCase('tr-TR')] || '#ddd';
        // Unknown colours use the actual product image instead of an invented hue.
        if (!palette[v.color.toLocaleLowerCase('tr-TR')] && v.imageSmall) dot.style.backgroundImage = `url(${JSON.stringify(v.imageSmall)})`;
        if (!v.available) dot.classList.add('kc-color-unavailable');
        button.append(dot);
        button.addEventListener('click', () => this.selectVariant(v.id));
        holder.append(button);
      });
      if (values.length > limit) {
        const more = document.createElement('a');
        more.className = 'kc-extra-colors';
        more.href = this.dataset.productUrl;
        more.textContent = `+${values.length - limit}`;
        more.setAttribute('aria-label', `${this.dataset.kcTitle} ürününün diğer ${values.length - limit} rengini gör`);
        holder.append(more);
      }
    }
    selectColor(color) {
      const matches = this.variants.filter(v => v.color === color);
      const variant = matches.find(v => v.available) || matches[0];
      if (variant) this.selectVariant(variant.id);
    }
    selectVariant(id) {
      const v = this.variants.find(item => String(item.id) === String(id));
      if (!v || this.renderedVariantId === String(v.id)) return;
      this.renderedVariantId = String(v.id);
      this.dataset.selectedId = String(v.id);
      this.querySelectorAll('[data-product-link]').forEach(a => a.href = v.url);
      const img = this.querySelector('[data-product-image]');
      if (img && v.image) {
        const box = img.parentElement;
        box.dataset.kcMediaState = 'loading';
        if (this.selectedImage && this.selectedImage !== v.image) img.loading = 'eager';
        this.selectedImage = v.image;
        img.onload = () => { if (img.complete && img.naturalWidth > 0) box.dataset.kcMediaState = 'ready'; };
        img.onerror = () => { box.dataset.kcMediaState = 'error'; };
        img.srcset = `${v.imageSmall} 360w, ${v.imageMedium} 540w, ${v.image} 720w`;
        img.src = v.image;
        if (img.complete && img.naturalWidth > 0) box.dataset.kcMediaState = 'ready';
        img.alt = this.dataset.kcTitle + (v.color ? ' – ' + v.color : '');
      }
      this.querySelector('[data-price]').textContent = v.price;
      const compare = this.querySelector('[data-compare]'); compare.textContent = v.compare; compare.hidden = !v.compare;
      this.querySelector('[data-sold-out]').hidden = v.available;
      const label = this.querySelector('[data-color-label]'); if (label) label.textContent = v.color;
      this.querySelectorAll('[data-color]').forEach(button => {
        const selected = button.dataset.color === v.color;
        button.setAttribute('aria-pressed', String(selected));

      });
      const form = this.querySelector('form');
      if (form) {
        form.elements.id.value = v.id;
        form.elements.quantity.value = v.quantity;
        form.dataset.increment = String(v.increment || 1);
        form.dataset.maximum = JSON.stringify(v.maximum ?? null);
        form.dataset.available = String(v.available);
        const button = form.querySelector('[data-add]');
        button.dataset.available = String(v.available);
        button.disabled = !v.available;
        form.querySelector('[data-add-label]').textContent = v.available ? 'Sepete ekle' : 'Stokta yok';
        form.dispatchEvent(new CustomEvent('kc-variant', {detail: v}));
      }
    }
  });
  window.matchMedia('(max-width: 749px)').addEventListener('change', () => {
    document.querySelectorAll('kc-product-card').forEach(card => {
      if (!card.initialized) return;
      const id = card.dataset.selectedId || card.dataset.defaultId;
      card.buildColors();
      card.renderedVariantId = null;
      card.selectVariant(id);
    });
  });
})();


